module.exports = __webpack_public_path__ + "static/media/EE.6063ed27.png";